import React, {Component} from 'react';
import {Link} from 'react-router'
import InternalImageV2 from './internal-image-v2';
import Icon from './icon';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {isEnglish, saveLanguageCookie} from '../localization/language-cookie';

import * as appActions from '../actions/app';

class AppHeader extends Component {

    isURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return pattern.test(str);
    }
    onNavigate() {
        this.props.actions.hideNavBar();
    }

    getLinkDisplay(menu) {
        const label = isEnglish()
            ? menu.title_en
            : menu.title_lt;
        if (this.isURL(menu.url)) {
            return (
                <a href={menu.url}>{label}</a>
            )
        }
        return (
            <Link to={menu.url} onClick={this.onNavigate.bind(this)}>{label}</Link>
        )
    }

    render() {
        const menu = window.CARE_CONFIG.settings.menu || [];
        return (
            <header className="site-header">

                <div className="container">
                    <div className="mobile-wrapper">
                        <div className="logo">
                            <Link to={'/'} onClick={this.onNavigate.bind(this)}>
                                <InternalImageV2
                                  filename={window.CARE_CONFIG.settings.logo ? window.CARE_CONFIG.settings.logo.filename : undefined }
                                  alt={window.CARE_CONFIG.settings.title}
                                />
                            </Link>
                        </div>
                        <a className="menu-button" onClick={this.props.actions.toggleNavBar}>
                            <Icon icon="menu" size="s"/>
                        </a>
                    </div>
                    <ul className={classnames('nav', this.props.expanded && 'active')}>
                        {menu.map((menu, index) => {
                            return (
                                <li key={index}>
                                    {this.getLinkDisplay(menu)}
                                </li>
                            )
                        })}

                    </ul>
                    {window.CARE_CONFIG.settings.localization_enabled? this.renderLangSwitcher(): null}

                </div>
            </header>
        )
    }

    renderLangSwitcher(){
        return (<div style={{padding: '8px 15px'}}>
          {['lt', 'en'].map(
            (lang)=>{
              return <a style={{paddingRight: '10px', textTransform: 'uppercase'}} onClick={()=>{
                  saveLanguageCookie(lang);
                  window.location.reload();
              }} key={lang}><img src={require(`../../images/flag-${lang}.png`)}/></a>
            }

          )}
        </div>)
    }

}
// <li>
//     <Link to={'/'} onClick={this.onNavigate.bind(this)}>{LocalizedStrings.hello}</Link>
// </li>
// <li>
//     <Link to={'/posts'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.news}</Link>
// </li>
// <li>
//     <Link to={'/regulations'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.regulations}</Link>
// </li>
// <li>
//     <Link to={'/stages'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.stages}</Link>
// </li>
// <li>
//     <Link to={'/results'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.results}</Link>
// </li>
//
// <li>
//     <Link to={'/archive'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.archive}</Link>
// </li>
// <li>
//     <Link to={'/contact'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.contacts}</Link>
// </li>
// <li>
//     <Link to={'/about'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.about}</Link>
// </li>

export default connect(function(state) {
    return {expanded: state.app.expandedNav}
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...appActions
        }, dispatch)
    };
})(AppHeader);



// WEBPACK FOOTER //
// ./src/js/components/app-header.js